import beautifyNumber from '../../../helpers/beautifyNumber';
import clearNumber from '../../../helpers/clearNumber';
import { phoneNumberRegex } from '../../../constants';

const price = value => beautifyNumber(+clearNumber(value));

const publishNormalizers = {
  area: value => clearNumber(value),
  apartments: (value, previousValue) => {
    if (value) {
      if (value.toString().match(/^(\d{0,4}(\.[0|5]?|[.])?)$/)) {
        return value;
      }
      return previousValue;
    }
    return '';
  },
  rooms: (value, previousValue) => {
    if (value) {
      const normalized = value.toString().replace(',', '.');
      if (normalized.match(/^(\d{0,2}(\.[0|5]?|[.])?)$/)) {
        return normalized;
      }
      return previousValue;
    }
    return '';
  },
  'floor.out_of': (value, previousValue) => {
    if (!value.length || isNaN(value) || +value === 0) {
      return '';
    }
    if (value > 99) {
      return +previousValue;
    }
    return +value;
  },
  'floor.on_the': (value, previousValue) => {
    if (isNaN(value) || value === '') {
      return '';
    }
    if (value > 99) {
      return +previousValue;
    }
    return +value;
  },
  construction_year: (value, previousValue) => {
    if (isNaN(value)) {
      return undefined;
    }
    if (value > new Date().getFullYear() + 10) {
      return previousValue;
    }
    return value;
  },
  working_since: (value, previousValue) => {
    if (isNaN(value)) {
      return undefined;
    }
    if (value > new Date().getFullYear()) {
      return previousValue;
    }
    return value;
  },
  phone: (value, previousValue) => {
    if (value || value === '') {
      if (value.toString().match(phoneNumberRegex) || !value.length) {
        return value;
      }
      return previousValue;
    }
    return undefined;
  },
  price,
  numbers: value => clearNumber(value),
  description: value => ((value === '') ? undefined : value),
  date: value => ((value === null) ? '' : value),
  rental: (value, previousValue) => {
    if (isNaN(value) || value === '' || +value === 0) {
      return '';
    }
    if (value > 12) {
      return previousValue;
    }
    return value;
  },
  house_number: value => ((+value === 0) ? '' : value)
};

export { price };

export default publishNormalizers;
